import { render, staticRenderFns } from "./AllText.vue?vue&type=template&id=b2feeace&scoped=true&"
import script from "./AllText.vue?vue&type=script&lang=js&"
export * from "./AllText.vue?vue&type=script&lang=js&"
import style0 from "./AllText.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AllText.vue?vue&type=style&index=1&id=b2feeace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2feeace",
  null
  
)

export default component.exports